import React, { useRef, useState } from "react";
import { PhosphorBracketsCurlyButton } from "components/Atoms/PhosphorIconButton";
import SelectMergeFieldModal from "components/MergeField/SelectMergeFieldModal/SelectMergeFieldModal";
import { TextArea } from "components/Atoms/formInputs/TextArea";

interface Props {
  focusOnMount?: boolean
  maxLength: number
  value: string
  onChange: (newValue: string) => void
  onCtrlEnter?: () => void
  onEsc?: () => void
  sectionName: string
  availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
  rows: number
}

const OptionalTextAreaInputWithMergeField = (props: Props) => {
  const [isMergeFieldModalOpen, setIsMergeFieldModalOpen] = useState(false);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const onMergeFieldSelected = (mergeField: string) => {
    const { selectionStart, selectionEnd } = textAreaRef.current;
    const newValue = props.value.substring(0, selectionStart) + mergeField + props.value.substring(selectionEnd);
    props.onChange(newValue);
    setIsMergeFieldModalOpen(false);
    setTimeout(() => {
      const cursorPosition = selectionStart + mergeField.length;
      textAreaRef.current.setSelectionRange(cursorPosition, cursorPosition);
      textAreaRef.current.focus();
    }, 1);
  }

  const onSelectMergeFieldModalClose = () => {
    setIsMergeFieldModalOpen(false);
    textAreaRef.current.focus();
  }

  const rows = props.rows ?? 6;

  return <div className="flex gap">
    <TextArea
      rows={rows}
      ref={textAreaRef}
      value={props.value}
      onChange={props.onChange}
      maxLength={props.maxLength}
      onCtrlEnter={props.onCtrlEnter}
      onEsc={props.onEsc}
      focusOnMount={props.focusOnMount}
    />
    <PhosphorBracketsCurlyButton
      layout="in-square"
      selectedStyle="green-bg"
      onClick={() => setIsMergeFieldModalOpen(true)}
      iconSize="large"
    />
    <SelectMergeFieldModal
      sectionName={props.sectionName}
      availableMergeFieldTopics={props.availableMergeFieldTopics}
      isOpen={isMergeFieldModalOpen}
      onClose={onSelectMergeFieldModalClose}
      onSelect={onMergeFieldSelected}
    />
  </div>;
}

export default OptionalTextAreaInputWithMergeField;